import "core-js/modules/es.array.reverse.js";
var _class, _class2;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import { Component } from "react";
import CommonStrata from "../../Models/Definition/CommonStrata";
import Styles from "./parameter-editors.scss";
import { jsx as _jsx } from "react/jsx-runtime";
let GenericParameterEditor = observer(_class = (_class2 = class GenericParameterEditor extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }
  onChange(e) {
    this.props.parameter.setValue(CommonStrata.user, e.target.value);
  }
  render() {
    const value = this.props.parameter.value || "";
    return /*#__PURE__*/_jsx("input", {
      className: Styles.field,
      type: "text",
      onChange: this.onChange.bind(this),
      value: value
    });
  }
}, _applyDecoratedDescriptor(_class2.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onChange"), _class2.prototype), _class2)) || _class;
export { GenericParameterEditor as default };